export default __webpack_public_path__ + "static/home-page-2-38a29fd2e0dea4b9a5d7fcf990b75458.png";